import React from 'react';
import { useModalEscapeKey } from '../../utils/useModalEscapeKey';
import './AdminColumnExportModal.css';
import './FmModal.css';

/**
 * @typedef {{ id: string; label: string }} ExportColumnDef
 */

/**
 * @param {object} props
 * @param {'print'|'copy'} props.mode
 * @param {ExportColumnDef[]} props.columns
 * @param {Set<string>} props.selectedIds
 * @param {(updater: (prev: Set<string>) => Set<string>) => void} props.onChangeSelected
 * @param {() => void} props.onCancel
 * @param {(selectedColumnIds: string[]) => void} props.onConfirm
 * @param {(selectedColumnIds: string[]) => void} [props.onPrint] // alias for onConfirm (same contract)
 * @param {() => void} [props.onResetDefaults]
 */
export default function AdminColumnExportModal({
  mode,
  columns,
  selectedIds,
  onChangeSelected,
  onCancel,
  onConfirm,
  onPrint,
  onResetDefaults,
}) {
  const confirmHandler = onConfirm ?? onPrint;

  const handleConfirm = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!selectedIds.size) return;
    if (mode === 'print') console.log('print callback:', typeof onPrint);
    if (typeof confirmHandler !== 'function') return;
    confirmHandler(Array.from(selectedIds));
  };
  const toggle = (id) => {
    onChangeSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const selectAll = () => {
    onChangeSelected(new Set(columns.map((c) => c.id)));
  };

  useModalEscapeKey(true, onCancel);

  return (
    <div className="fm-modal-overlay" onClick={onCancel} role="presentation">
      <div
        className="fm-modal fm-modal--sm admin-column-export-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="admin-column-export-title"
      >
        <div className="fm-modal-header">
          <h2 className="fm-modal-title" id="admin-column-export-title">
            {mode === 'print' ? 'Print table' : 'Copy table'} — choose columns
          </h2>
          <button type="button" className="fm-modal-close" onClick={onCancel} aria-label="Close">
            ✕
          </button>
        </div>
        <div className="fm-modal-body">
          <div className="admin-column-export-grid">
            {columns.map((col) => (
              <label key={col.id} className="admin-column-export-item">
                <input
                  type="checkbox"
                  checked={selectedIds.has(col.id)}
                  onChange={() => toggle(col.id)}
                />
                <span>{col.label}</span>
              </label>
            ))}
          </div>
        </div>
        <div className="fm-modal-footer">
          <div className="fm-modal-footer-start">
            <button type="button" className="fm-modal-btn fm-modal-btn-cancel" onClick={selectAll}>
              Select all
            </button>
            {onResetDefaults && (
              <button type="button" className="fm-modal-btn fm-modal-btn-cancel" onClick={onResetDefaults}>
                Reset defaults
              </button>
            )}
          </div>
          <button type="button" className="fm-modal-btn fm-modal-btn-cancel" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="fm-modal-btn fm-modal-btn-primary"
            onClick={handleConfirm}
            disabled={!selectedIds.size}
          >
            {mode === 'print' ? 'Print' : 'Copy'}
          </button>
        </div>
      </div>
    </div>
  );
}
